import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import HelpOutlineRoundedIcon from "@mui/icons-material/HelpOutlineRounded";
import { Button, Stack, Tooltip, Typography } from "@mui/material";

interface Props {
  title: string;
  onClose: () => void;
}

const FieldDestinationHeader = ({ title, onClose }: Props) => (
  <Stack direction="row" spacing={0.5} sx={{ alignItems: "center", pb: 1, px: 0.5 }}>
    <Stack direction="row" spacing={0.5} sx={{ alignItems: "center", flex: 1 }}>
      <Typography variant="caption" color="textSecondary">
        Adding fields here
      </Typography>
      <Tooltip arrow title="Click Add beside a field to add it to this container.">
        <HelpOutlineRoundedIcon color="secondary" />
      </Tooltip>
    </Stack>
    <Button
      color="primary"
      startIcon={<CheckRoundedIcon />}
      aria-label={`Ok, stop adding fields to ${title}`}
      onClick={onClose}
    >
      Done
    </Button>
  </Stack>
);

export default FieldDestinationHeader;
